import { Check, Clock, Lock } from "lucide-react";

const STATUS_CONFIG = {
    verfuegbar: {
        label: "Verfügbar",
        className: "bg-green-50 text-green-800 border-green-200",
        dotClass: "bg-green-500",
        icon: Check,
    },
    reserviert: {
        label: "Reserviert",
        className: "bg-amber-50 text-amber-800 border-amber-200",
        dotClass: "bg-amber-500",
        icon: Clock,
    },
    verkauft: {
        label: "Verkauft",
        className: "bg-stone-200 text-stone-700 border-stone-300",
        dotClass: "bg-stone-500",
        icon: Lock,
    },
};

export const AvailabilityBadge = ({ status, size = "md", className = "" }) => {
    const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.verfuegbar;
    const sizes = size === "lg"
        ? "px-3 py-1.5 text-xs"
        : size === "sm"
            ? "px-2 py-0.5 text-[10px]"
            : "px-2.5 py-1 text-xs";

    return (
        <span
            className={`inline-flex items-center gap-2 ${sizes} font-body font-medium uppercase tracking-[0.15em] border ${cfg.className} ${className}`}
            data-testid={`availability-badge-${status}`}
        >
            <span className={`w-1.5 h-1.5 rounded-full ${cfg.dotClass}`} />
            {cfg.label}
        </span>
    );
};

export const STATUS_OPTIONS_SELL = [
    { value: "verfuegbar", label: "Verfügbar" },
    { value: "reserviert", label: "Reserviert" },
    { value: "verkauft", label: "Verkauft" },
];
